import Layout from '@/views/Layout.vue';
import routesAccounts from './accounts.routes';
import routesConciliation from './conciliation.routes';
import routesConciliation2 from './conciliation2.routes';
import routesDistributors from './distributors.routes';
import routesGroups from './groups.routes';
import routesInterveners from './interveners.routes';
import routesIssues from './issues.routes';
import routesMissmatchMonitor from './mismatch-monitor.routes';
import routesOperations from './operations.routes';
import routesPermissionSets from './permission-sets.routes';
import routesUsers from './users.routes';

export default [
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '/',
                name: '_dashboard',
                meta: {
                    isSection: true
                },
                component: () => import('@/views/dashboard/index.vue')
            },
            {
                path: '/dashboard',
                name: 'dashboard',
                meta: {
                    isSection: true
                },
                component: () => import('@/views/dashboard/index.vue')
            },
            {
                path: '/import',
                name: 'import',
                meta: {
                    isSection: true
                },
                component: () => import('@/views/import-rd/index.vue')
            }
        ]
            .concat(routesUsers)
            .concat(routesDistributors)
            .concat(routesGroups)
            .concat(routesPermissionSets)
            .concat(routesInterveners)
            .concat(routesAccounts)
            .concat(routesIssues)
            .concat(routesOperations)
            .concat(routesConciliation)
            .concat(routesConciliation2)
            .concat(routesMissmatchMonitor)
    }
];
